
export default {
  props: {
    layout: {
      default: 'ring', // ring | spinner | blades
      type: String,
    },
  },
}
